export default __webpack_public_path__ + "static/media/store-logo1.f93cdfa7.png";